import { render, staticRenderFns } from "./AmmunitionAdditional.vue?vue&type=template&id=c8df56cc&"
import script from "./AmmunitionAdditional.vue?vue&type=script&lang=ts&"
export * from "./AmmunitionAdditional.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports